import i18n from 'i18next';
import { z } from 'zod';

export const validateEmailSchema = z.object({
  email: z.string().email('Invalid email'),
});

export const pinSchema = z.object({
  pin: z.string()
    .min(6, i18n.t("inputs.pin.error"))
    .max(6, i18n.t("inputs.pin.error")),
});

export const signupSchema = z.object({
  email: z.string().email(i18n.t("inputs.email.error")),
  firstName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.firstName.error"))
    .max(30, i18n.t("inputs.firstName.maxLengthError")),
  lastName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.lastName.error"))
    .max(30, i18n.t("inputs.lastName.maxLengthError")),
  phoneCode: z.string(),
  phoneNumber: z.string(),
  language: z.string(),
}).refine(
  data => !(data.phoneNumber && !data.phoneCode),
  {
    message: i18n.t("inputs.phoneNumber.error"),
    path: ['phoneCode'],
  },
);